import ESI from "@JohnLewisPartnership/jl-esi-components";
export const AddToBasketESI = ({
  productId,
  quoteId,
}: {
  productId: string;
  quoteId: string;
}) => {
  const src = `/esi/add-to-basket/${productId}/?clientId=electricals&enabled=true${
    quoteId ? `&tradeInQuoteId=${quoteId}` : ""
  }`;

  return <ESI src={src} id="add-trade-in-to-basket-esi" />;
};
